import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'

type Props = {
  dataCy?: string
  disabled?: boolean
  label: string
  onClick: () => void
  size: 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large'
  type?: 'blue' | 'outlined'
}

const CautionButton: FC<Props> = React.memo((props) => {
  const { dataCy = 'default', disabled, label, onClick, size, type } = props
  const sizeStyle = (() => {
    switch (size) {
      case 'xxsmall':
        return styles.button_xxsmall
      case 'xsmall':
        return styles.button_xsmall
      case 'small':
        return styles.button_small
      case 'medium':
        return styles.button_medium
      case 'large':
        return styles.button_large
      default:
        return styles.button_medium
    }
  })()

  const className = disabled
    ? `${sizeStyle} ${styles.button_grey_disabled}`
    : type === 'blue'
    ? `${sizeStyle} ${styles.button_blue_main}`
    : type === 'outlined'
    ? `${sizeStyle} ${styles.button_caution_outlined}`
    : `${sizeStyle} ${styles.button_caution}`

  return (
    <button className={className} data-cy={`caution-button-${dataCy}`} disabled={disabled} onClick={onClick}>
      {label}
    </button>
  )
})

export default CautionButton
